// extracted by mini-css-extract-plugin
export default {"component":"b1Qi8T","badge":"c1Qi8T","avatar":"d1Qi8T","icon":"e1Qi8T","branded":"f1Qi8T"};